import { createAction } from 'redux-act';

import * as testDevices from '../../core/testDevices';

export const fetchTestDevices = createAction(
  'get all testDevices',
);
export const fetchTestDevicesSuccess = createAction(
  'get all testDevices success',
);
export const fetchTestDevicesFail = createAction(
  'get all testDevices fail',
  (error) => error
);

export const addTestDevice = createAction(
  'add new testDevice',
);
export const addTestDeviceSuccess = createAction(
  'add new testDevice success',
);
export const addTestDeviceFail = createAction(
  'add new testDevice fail',
  (error) => error
);

export const updateTestDevice = createAction(
  'update testDevice'
);
export const updateTestDeviceSuccess = createAction(
  'update testDevice success'
);
export const updateTestDeviceFail = createAction(
  'update testDevice fail',
  (error) => error
);

export const deleteTestDevice = createAction(
  'delete testDevice'
);
export const deleteTestDeviceSuccess = createAction(
  'delete testDevice success'
);
export const deleteTestDeviceFail = createAction(
  'delete testDevice fail',
  (error) => error
);

export const openEditTestDevice = createAction(
  'open edit testDevice modal'
);
export const closeEditTestDevice = createAction(
  'close edit testDevice modal'
);

export const openTestModeMessage = createAction(
  'open test mode message modal'
);
export const closeTestModeMessage = createAction(
  'close test mode message modal'
);

export const reducer = {
  [fetchTestDevices]: (state, payload) =>
    testDevices.fetchTestDevices(state, payload),
  [fetchTestDevicesSuccess]: (state, payload) =>
    testDevices.fetchTestDevicesSuccess(state, payload),

  [addTestDeviceSuccess]: (state, payload) =>
    testDevices.addTestDeviceSuccess(state, payload),
  [addTestDeviceFail]: (state, payload) =>
    testDevices.addTestDeviceFail(state, payload),

  [updateTestDeviceSuccess]: (state, payload) =>
    testDevices.updateTestDeviceSuccess(state, payload),
  [updateTestDeviceFail]: (state, payload) =>
    testDevices.updateTestDeviceFail(state, payload),

  [deleteTestDeviceSuccess]: (state, payload) =>
    testDevices.deleteTestDeviceSuccess(state, payload),
  [deleteTestDeviceFail]: (state, payload) =>
    testDevices.deleteTestDeviceFail(state, payload),

  [openEditTestDevice]: (state, payload) =>
    testDevices.openEditTestDevice(state, payload),
  [closeEditTestDevice]: (state, payload) =>
    testDevices.closeEditTestDevice(state, payload),

  [openTestModeMessage]: (state) =>
    testDevices.openTestModeMessage(state),
  [closeTestModeMessage]: (state) =>
    testDevices.closeTestModeMessage(state),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/testDevices.module.js
 **/